<template>
	<div id="sidebar_wrap">
		<div class="subject_wrap">
			<div class="title" style='border-bottom:1px solid #eee; '>
				<div>
					<span class="badgeColor"></span>
					<span>快速切换</span>
				</div>
				<div style='margin-top: 15px;'>
					<el-input v-model='filterText' placeholder='请输入筛选' size='mini' clearable></el-input>
				</div>
			</div>
			<div style='padding: 10px 5px;' class='allContainer'>
				<el-scrollbar class="default-scrollbar">
					<div class="subjectTree">
						<el-tree
							:data="datas"
							:render-content="renderContent"
							:expand-on-click-node="false"
							node-key="id"
							ref='tree'
							:filter-node-method="filterNode"
							@node-click="handleNodeClick">
						</el-tree>
					</div>
				</el-scrollbar>
			</div>
			
			<!-- 科目树 -->
			<!-- <el-tabs v-model="nowTab" @tab-click="handleTabClick">
				<template v-for="(item, index) in subjectTypeList">
					<el-tab-pane
						:key="index"
						:label="item"
						:name="item">
						
					</el-tab-pane>
				</template>
			</el-tabs> -->
			
		</div>
	</div>
</template>

<script>
export default {
	props:{
		formData:Object,
		refreshTreeBar:Boolean
	},
	data () {
		return {
			isFirstActive:false,
			nowTab: '',
			subjectTypeList: [],
			datas: [],
			filterText:"",
		}
	},
	created(){
		this.getSubjectType();
		
	},
	computed:{
		getClickCache() {
			return this.$store.state.loadstatus.isClickCache;
		}
	},
	methods: {
		 filterNode(value, data) {
	        if (!value) return true;
	        return data.name.indexOf(value) !== -1 || data.code.indexOf(value) !== -1;
	      },
		// tab点击事件
		// handleTabClick(type , e) {
		// 	this.getSubjectByType(type.name , type.index)
		// },
		// 根据类别获取科目树
		getSubjectByType(val) {
				try {
					this.$http.post('subject/ajaxgetTree' , {isSubject:"3",start:val.start,end:val.end}).then(res=>{
						if(res&&res.data) {
							this.datas = res.data.data;
						}
						
					})
				}catch(e) {

				}
		},
		// 获取科目类别
		getSubjectType() {
			try {
				this.$http.post('subject/getSubjectType' , {type: 1}).then(res=>{
					if(res) {
						this.subjectTypeList = res.data.data;
						this.nowTab = res.data.data[0];
						this.getSubjectByType(this.nowTab, '0');
						this.$emit('getSubjectType' , res.data.data);
					}
				})
			}catch(e) {
				console.log(e)
			}
		},
		// 渲染科目树 编码+名称
		renderContent (h, { node, data, store }) {
			return (
				<span class="custom-tree-node">
		            <span>{data.code} {data.name}</span>
	          	</span>);
		},
		// 科目选择
		handleNodeClick (data) {
			this.$emit('onHandleSubjectIdChange', data);
		},

	},
	activated() {
		if(this.getClickCache && this.isFirstActive) {
			this.getSubjectByType(this.formData);
		}
		this.isFirstActive = true;
		
	},
	watch:{
		filterText(val) {
        this.$refs.tree.filter(val);
      },
      formData:{
      	handler(val){
      		this.getSubjectByType(val);
      	},
      	deep:true,
      	immediate:false,
      },
      refreshTreeBar(val) {
      	this.getSubjectByType(this.formData)
      }
	}
}
</script>
<style lang='less' scoped>
	
</style>


// WEBPACK FOOTER //
// src/components/subject/SubjectSiderbar.vue